<template>
  <v-navigation-drawer
    :mini-variant="mini"
    clipped
    absolute
    permanent
    :width="230"
    :mini-variant-width="80"
    app
    class="flex layout column navigation"
  >
    <div class="wrapper layout column">
      <v-list class>
        <v-list-item v-if="mini" @click.stop="toggleNavigation">
          <v-list-item-action>
            <v-icon>{{ icons.arrows.right }}</v-icon>
          </v-list-item-action>
        </v-list-item>

        <div v-if="!mini" class="logo-container px-3 layout align-center" avatar tag="div">
          <div class="logo">
            <img src="@/assets/iisy_black.svg" width="130" alt="Logo iisy" />
          </div>
          <v-spacer />
          <v-btn small icon @click.stop="toggleNavigation">
            <v-icon>{{ icons.arrows.left }}</v-icon>
          </v-btn>
        </div>
        <v-list-item class="px-3" tag="div">
          <v-list-item-avatar>
            <v-avatar size="36px" style="background-color: var(--dark)">
              <span class="white--text">{{ avatar }}</span>
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-if="name">
              {{ name }}
            </v-list-item-title>
            <v-list-item-title v-if="!name">
              Loading...
            </v-list-item-title>

            <!-- <v-list-item-subtitle>{{ role }}</v-list-item-subtitle> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-show="!mini && selected">
        <product-country-select v-show="!mini" />
      </template>
      <v-divider />

      <!-- <v-divider light></v-divider> -->
      <v-list nav class="mt-2 px-4" dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          dense
          class="mb-2"
          :to="link({ name: item.linkTo })"
        >
          <v-list-item-action>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  {{ item.icon }}
                </v-icon>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-spacer />
      <v-list nav class="mt-2 px-4" dense>
        <v-list-item v-if="isLoggedIn" class="mb-2" @click.prevent="logout">
          <v-list-item-action>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon color="primary">
                  {{ icons.navigation.lockout }}
                </v-icon>
              </template>
              <span>Logout</span>
            </v-tooltip>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isAdmin" class="mb-2" @click.prevent="toAdminArea()">
          <v-list-item-action>
            <v-tooltip right>
              <v-icon color="primary">
                {{ icons.navigation.download }}
              </v-icon>
              <span>Admin Area</span>
            </v-tooltip>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Admin Area</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isCreator || isAdmin" class="mb-2" @click.prevent="downloadClient">
          <v-list-item-action>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon v-if="!clientLoading" color="primary">
                  {{ icons.navigation.download }}
                </v-icon>
                <v-progress-circular v-else small color="primary" indeterminate />
              </template>
              <span>Download Client</span>
            </v-tooltip>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Download Client</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item class="mb-2" @click.prevent="exportExcel">
          <v-list-item-action>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon color="primary">{{ icons.navigation.download }}</v-icon>
              </template>
              <span>Export Excel</span>
            </v-tooltip>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Export Excel</v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->
      </v-list>
      <export-button
        :country="selected.country"
        :product="selected.product._id"
        :customer="customer"
        v-if="(!isCreator || isAdmin) && selected.country && selected.product && selected.product._id"
      />
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { NAVIGATION, PRODUCTS_SET_CURRENT } from '@/config/constants';
import * as _ from 'lodash';
import ExportButton from '@/components/export-button/ExportButton';
import icons from '@/mixins/icons';
import { getLatestClientVersion } from '../../services/graph/client.graph';
import create_data_link from '../../utils/create-data-link';
import axios from 'axios';
import ProductAndCountrySelector from '../ProductCountrySelector.vue';
import AuthorizationService from '../../services/AuthorizationService';
import { link } from '../../router';
const service = new AuthorizationService();

export default {
  name: 'NavigationComponent',
  components: { ExportButton, productCountrySelect: ProductAndCountrySelector },
  mixins: [icons],
  data() {
    return {
      clientLoading: false,
      drawer: true,
      items: NAVIGATION,
      disabled: this.products ? this.products.length === 0 : false,
      product: this.$route.params.product ? this.$route.params.product : null,
      country: this.$route.params.country ? this.$route.params.country : null,
      customer: localStorage.getItem('customer')
    };
  },
  watch: {
    // selected: {
    //   handler: function() {
    //     this.product = this.selected.product;
    //     this.country = this.selected.country;
    //     if (this.selected.product && this.selected.country) {
    //       this.getFilteredFlows("flows");
    //       this.getFilteredChapters("chapters");
    //       // this.getFilteredSlides();
    //       this.$store.commit("flows/removeActive");
    //       this.$store.commit("chapters/removeActive");
    //     }
    //   },
    //   deep: true
    // },
    products() {
      if (this.products.length > 0) {
        this.disabled = false;
      }
    },
    product() {
      this.updateCountries();
      this.updateCurrentProduct();
    },
    country() {
      this.updateCurrentProduct();
    }
  },
  computed: {
    isCreator() {
      return service.isCreator();
    },
    isAdmin() {
      return service.isAdmin();
    },
    mini: {
      get() {
        return this.$store.state.navigation.mini;
      },
      set() {}
    },
    ...mapState({
      isLoading: state => state.isLoading
    }),
    ...mapState('auth', {
      isLoggedIn: state => state.isLoggedIn
    }),
    ...mapState('user', {
      name: state => state.me.name,
      roles: state => state.me.roles,
      email: state => state.me.email
    }),
    ...mapState('slides', {
      active: state => state.active,
      tree: state => state.tree
    }),
    ...mapState('product', {
      products: state => state.products,
      selected: state => state.selected
    }),
    ...mapGetters('product', {
      completeProduct: 'getCompleteProduct'
    }),
    countries() {
      const product = this.$store.getters['product/getCompleteProduct'](this.product);
      if (product) {
        return product.countries;
      }
      return [];
    },
    role() {
      if (this.roles) {
        return this.roles[0] ? this.roles[0].toUpperCase() : null;
      }

      return '';
    },
    avatar() {
      if (this.email) {
        const a = this.email.split('.');
        if (a.length >= 2) {
          const prename = a[0].toUpperCase().slice(0, 1);
          const name = a[1].toUpperCase().slice(0, 1);
          return prename + name;
        }
      }

      return '';
    }
  },
  mounted() {
    // this.getProducts();
    // const route = this.$route;
    // if (route.params.country && route.params.product) {
    //   this.product = route.params.product;
    //   this.country = route.params.country;
    // }
    if (this.selected.product && this.selected.product._id) {
      this.product = this.selected.product;
      this.country = this.selected.country;
    }
  },
  methods: {
    link(to) {
      return link(to);
    },
    ...mapActions({
      getProducts: 'product/getAllProducts',
      getFilteredSlides: 'filter/filterSlides',
      getFilteredChapters: 'filter/filterCollections',
      getFilteredFlows: 'filter/filterCollections',
      doLogout: 'auth/logout',
      toggleNavigation: 'navigation/toggle'
    }),
    toAdminArea() {
      location.replace('/admin');
    },
    async logout() {
      this.doLogout();
      this.$router.push({ name: 'login' });
    },
    exportExcel() {
      const { ExportService } = require('@/services/modules/export');
      new ExportService().donwloadExcel(this.$store.state.auth.token, {
        product: this.selected.product._id,
        country: this.selected.country
      });
    },
    downloadClient() {
      const url = new URL('https://github.com/Fishermanhealth-Gmbh/client/releases');
      const _window = window.open(url, '_blank');
      _window.focus();
    },
    async updateCurrentProduct() {
      const params = {
        country: this.country,
        product: this.product
      };

      try {
        await this.$router.replace({
          name: this.$route.name || 'work',
          params: {
            product: this.product ? this.product._id : null,
            country: this.country && this.country
          },
          query: this.$route.query
        });
      } catch (e) {}

      await this.$store.dispatch(PRODUCTS_SET_CURRENT, params);
      if (this.country && this.product) {
        await this.$store.dispatch('getAll');
        await this.$store.dispatch('getAllForDashboard');
        this.getFilteredFlows('flows');
        this.getFilteredChapters('chapters');
        // this.getFilteredSlides();
        this.$store.commit('flows/removeActive');
        this.$store.commit('chapters/removeActive');

        // window.location.assign(config.FRONTEND_BASE_URL);
      }
    },

    updateCountries() {
      const product = _.find(this.products, { _id: this.product });
      if (product) {
        this.countries = product.countries;
      }
    }
  }
};
</script>

<style scoped>
.navigation {
  max-width: 230px;
}

.loading {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  flex: 1 1 auto;
  margin-bottom: 10px;
}

.logo-container {
  margin-top: 30px;
  margin-bottom: 20px;
}

.flex {
  display: flex;
  flex-direction: column;
}

.wrapper {
  height: 100%;
}
</style>
